import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AppComponent } from '../../../app.component';

class LocalStorage implements Storage {
  [name: string]: any;
  readonly length!: number;
  clear(): void {}
  getItem(key: string): string | null {return null;}
  key(index: number): string | null {return null;}
  removeItem(key: string): void {}
  setItem(key: string, value: string): void {}
}

@Injectable({ providedIn: 'root' })
export class LocalStorageRefService {
  private readonly storage: Storage;

  constructor(@Inject(PLATFORM_ID) platformID: Object) {
    this.storage = new LocalStorage();
    // Below is used for Angular Server Side Rendering
    if (AppComponent.isBrowser) this.storage = localStorage;
  }

  get localStorage(): Storage {
    return this.getLocalStorage();
  }

  getLocalStorage(): Storage {
    return this.storage;
  }
}
